<template lang="pug">
.idiomas
  div(:class="iconeDeTraducaoDaClasseCSS")
  select(
    v-model="localidade"
    @change="mudarLocal"
  )
    option(
      v-for="(idioma, codigo) in idiomas"
      :value="codigo"
    ) {{ idioma }}
</template>

<script>
import './css/iconeTraducao.css'

export default {
  data () {
    return {
      localidade: this.$i18n.locale,
      iconeDeTraducaoDaClasseCSS: 'icon-traducao-linha-18px',
      idiomas: {
        en: 'en-us',
        pt: 'pt-br'
      }
    }
  },
  methods: {
    mudarLocal () {
      this.$i18n.locale = this.localidade
      this.verificarIdiomaEscolhido(this.localidade)
      // troca o título da página de acordo com o idioma
      // foi necessário fazer aqui pois o título é apenas definido no
      // index.html e não faz parte de nenhum componente, logo não é
      // possível usar o $t
      document.title = this.$t('componentes.idiomas.tituloDaPagina')
    },
    verificarIdiomaEscolhido (idioma) {
      const nomeDoStorageDoIdioma = 'idiomaBatePonto'
      const valorDoStorage = localStorage.getItem(nomeDoStorageDoIdioma)

      if (valorDoStorage) {
        localStorage.removeItem(nomeDoStorageDoIdioma)
      }

      localStorage.setItem('idiomaBatePonto', idioma)
    }
  }
}
</script>

<style scoped>

.idiomas {
  display: flex;
  justify-content: center;
}

select {
  color: #fff;
  background-color: #2C3E50;
  border: none;
}
</style>
